// extracted by mini-css-extract-plugin
export default {"block":"Login_block__QHo0S","link":"Login_link__14lym"};